import Wrapper from "./Wrapper";
import Properties from "./Properties";
import Metadata from "./Metadata";
import Layout from "./Layout";
import Issues from "./Issues";
import IssueEdit from "./IssueEdit";
import IssueNew from "./IssueNew";
import IssueWrapper from "./IssueWrapper";
import Volumes from "./Volumes";
import VolumeEdit from "./VolumeEdit";
import VolumeNew from "./VolumeNew";
import VolumeWrapper from "./VolumeWrapper";
import AccessWrapper from "./AccessWrapper";

export default {
  Wrapper,
  Properties,
  Metadata,
  Layout,
  Issues,
  IssueEdit,
  IssueNew,
  IssueWrapper,
  Volumes,
  VolumeEdit,
  VolumeNew,
  VolumeWrapper,
  AccessWrapper
};
